<div class="container">

  @if (editing) {
    <nav mat-tab-nav-bar class="sub-nav">
      <a mat-tab-link active="active">
        @if (field?.id) {
          Update {{field?.label}}
        }
        @if (!field?.id) {
          Add field
        }
      </a>
    </nav>
  }
  <ng-container *ngTemplateOutlet="InputFormContent"></ng-container>
  <ng-container *ngTemplateOutlet="ListingContent"></ng-container>
</div>

<ng-template #ListingContent>
  <!-- Fields listing -->
  <div class="row">
    <nav mat-tab-nav-bar class="sub-nav">
      <a mat-tab-link active="active">
        <span class="icon material-symbols-outlined" title="Fields">
          tune
          @if (fields?.length) {
            <span class="badge" color="accent">
              {{fields.length}}
            </span>
          }
        </span>
      </a>
    </nav>
    <div class="icons">
      <button mat-icon-button aria-label="Add field" color="none" [disabled]="!canEdit"
        (click)="toggleForm(null, true)">
        <mat-icon title="Add">add</mat-icon>
      </button>
    </div>
  </div>

  @if (!fields.length) {
    <div class="mat-body-strong">
      No fields found for this {{entity?.modelName}}
      <button mat-button color="accent" class="mat-inline-button" [disabled]="!canEdit" (click)="toggleForm(null, true)"
        aria-label="Add" title="Add">
      Add field?</button>
    </div>
  }

  <div class="list" cdkDropList (cdkDropListDropped)="drop($event)">
    @for (record of fields; track record) {
      <div class="list-card" cdkDrag>
        <div class="hover-icons">
          <a mat-icon-button [disabled]="!canEdit" (click)="toggleForm(record, true)" color="none" aria-label="Edit"
            title="Edit">
            <mat-icon>edit</mat-icon>
          </a>
          <a mat-icon-button [disabled]="!canEdit" (click)="delete(record)" color="warn" aria-label="Delete"
            title="Delete">
            <mat-icon>delete</mat-icon>
          </a>
        </div>
        <div class="body">
          <div class="mat-subtitle-1">
            {{record.label}} <span class="mat-caption">{{record.name}}</span>
          </div>
          <div class="mat-caption row">
            <span class="mat-body-strong">
              <span style="text-transform: capitalize;">{{record.type}}</span>
              @if (record.uom) {
                <span> ({{record.uom}})</span>
              }
            </span>
            @if (record.estimate_station_property) {
              <span>
                Est: {{record.estimate_station_property}}
              </span>
            }
          </div>
          <div class="tags muted">
            @if (record.is_optional) {
              <div class="tag">Optional</div>
            }
            @if (record.validation_rules?.required) {
              <div class="tag">Required</div>
            }
            @if (record.validation_rules?.min) {
              <div class="tag">
                Min: {{record.validation_rules?.min}}
              </div>
            }
            @if (record.validation_rules?.max) {
              <div class="tag">
                Max: {{record.validation_rules?.max}}
              </div>
            }
            @if (hasRange(record.range_values)) {
              <div class="tag">
                Range: {{record.range_values?.min}} - {{record.range_values?.max}}
              </div>
            }
            @if (record.recent_field) {
              <div class="tag">
                Recent field: <b>{{record.recent_field?.label}}</b>
                @if (record.recent_field_label) {
                  <span> ({{record.recent_field_label}})</span>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
  <!-- Fields listing -->
</ng-template>


<ng-template #InputFormContent>
  <!-- Field Form -->
  <form #vcInputForm [formGroup]="inputForm" [class.hide]="!editing">
    <section style="display: none;">
      <input matInput type="text" formControlName="id" />
      <input matInput type="number" formControlName="display_order" />
    </section>
    <!-- label section -->
    <section>
      <mat-form-field>
        <mat-label>Label</mat-label>
        <input matInput type="text" autocomplete="off" formControlName="label" (blur)="onLabelChange($event)"
          [errorStateMatcher]="matcher" />
        @if (inputForm.controls.label.hasError('required')) {
          <mat-error>
            This field is <strong>required</strong>
          </mat-error>
        }
        @if (inputForm.controls.label.hasError('error')) {
          <mat-error>
            {{inputForm.controls.label.errors.error}}
          </mat-error>
        }
      </mat-form-field>
    </section>
    <!-- /label section -->

    <!-- name section -->
    <section>
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input matInput type="text" autocomplete="off" formControlName="name" [errorStateMatcher]="matcher" />
        @if (inputForm.controls.name.hasError('required')) {
          <mat-error>
            This field is <strong>required</strong>
          </mat-error>
        }
        @if (inputForm.controls.name.hasError('error')) {
          <mat-error>
            {{inputForm.controls.name.errors.error}}
          </mat-error>
        }
      </mat-form-field>
    </section>
    <!-- /name section -->

    <!-- type section -->
    <section>
      <mat-form-field>
        <mat-label>Type</mat-label>
        <mat-select formControlName="type" [errorStateMatcher]="matcher">
          @for (type of fieldTypes; track type) {
            <mat-option [value]="type">
              {{type}}
            </mat-option>
          }
        </mat-select>
        @if (inputForm.controls.type.hasError('required')) {
          <mat-error>
            This field is <strong>required</strong>
          </mat-error>
        }
        @if (inputForm.controls.type.hasError('error')) {
          <mat-error>
            {{inputForm.controls.type.errors.error}}
          </mat-error>
        }
      </mat-form-field>
    </section>
    <!-- /name section -->

    <!-- uom section -->
    <section>
      <mat-form-field>
        <mat-label>UOM</mat-label>
        <input matInput type="text" autocomplete="off" formControlName="uom" [errorStateMatcher]="matcher" />
        @if (inputForm.controls.uom.hasError('required')) {
          <mat-error>
            This field is <strong>required</strong>
          </mat-error>
        }
        @if (inputForm.controls.uom.hasError('error')) {
          <mat-error>
            {{inputForm.controls.uom.errors.error}}
          </mat-error>
        }
      </mat-form-field>
    </section>
    <!-- /uom section -->

    <!-- is_optional section -->
    <div class="row">
      <div class="mat-body">Is Optional</div>
      <div class="icons">
        <mat-slide-toggle formControlName="is_optional"></mat-slide-toggle>
        @if (inputForm.get('is_optional').hasError('required')) {
          <mat-error>
            This field is <strong>required</strong>
          </mat-error>
        }
        @if (inputForm.get('is_optional').hasError('error')) {
          <mat-error>
            {{inputForm.get('is_optional').errors.error}}
          </mat-error>
        }
      </div>
    </div>
    <!-- /is_optional section -->

    <!-- validation rules -->
    <section formGroupName="validation_rules">
      <div class="row">
        <div class="mat-body-2">Validation</div>
      </div>

      <!-- required section -->
      <div class="row">
        <div class="mat-body">Required</div>
        <div class="icons">
          <mat-slide-toggle formControlName="required"></mat-slide-toggle>
          @if (inputForm.get('validation_rules.required').hasError('required')) {
            <mat-error>
              This field is <strong>required</strong>
            </mat-error>
          }
          @if (inputForm.get('validation_rules.required').hasError('error')) {
            <mat-error>
              {{inputForm.get('validation_rules.required').errors.error}}
            </mat-error>
          }
        </div>
      </div>
      <!-- /required section -->
      <!-- min section -->
      <div>
        <mat-form-field>
          <mat-label>Min</mat-label>
          <input matInput type="number" autocomplete="off" formControlName="min" [errorStateMatcher]="matcher" />
          @if (inputForm.get('validation_rules.min').hasError('required')) {
            <mat-error>
              This field is <strong>required</strong>
            </mat-error>
          }
          @if (inputForm.get('validation_rules.min').hasError('error')) {
            <mat-error>
              {{inputForm.get('validation_rules.min').errors.error}}
            </mat-error>
          }
        </mat-form-field>
      </div>
      <!-- /min section -->
      <!-- max section -->
      <div>
        <mat-form-field>
          <mat-label>Max</mat-label>
          <input matInput type="number" autocomplete="off" formControlName="max" [errorStateMatcher]="matcher" />
          @if (inputForm.get('validation_rules.max').hasError('required')) {
            <mat-error>
              This field is <strong>required</strong>
            </mat-error>
          }
          @if (inputForm.get('validation_rules.max').hasError('error')) {
            <mat-error>
              {{inputForm.get('validation_rules.max').errors.error}}
            </mat-error>
          }
        </mat-form-field>
      </div>
      <!-- /max section -->

    </section>
    <!-- /validation rules -->

    <!-- range_values -->
    <section formGroupName="range_values" [class.hide]="!recordRange">
      <div class="row">
        <div class="mat-body-2">Range</div>
      </div>

      <!-- min section -->
      <div>
        <mat-form-field>
          <mat-label>Min</mat-label>
          <input matInput type="number" autocomplete="off" formControlName="min" [errorStateMatcher]="matcher" />
          @if (inputForm.get('range_values.min').hasError('required')) {
            <mat-error>
              This field is <strong>required</strong>
            </mat-error>
          }
          @if (inputForm.get('range_values.min').hasError('error')) {
            <mat-error>
              {{inputForm.get('range_values.min').errors.error}}
            </mat-error>
          }
        </mat-form-field>
      </div>
      <!-- /min section -->
      <!-- max section -->
      <div>
        <mat-form-field>
          <mat-label>Max</mat-label>
          <input matInput type="number" autocomplete="off" formControlName="max" [errorStateMatcher]="matcher" />
          @if (inputForm.get('range_values.max').hasError('required')) {
            <mat-error>
              This field is <strong>required</strong>
            </mat-error>
          }
          @if (inputForm.get('range_values.max').hasError('error')) {
            <mat-error>
              {{inputForm.get('range_values.max').errors.error}}
            </mat-error>
          }
        </mat-form-field>
      </div>
      <!-- /max section -->

    </section>
    <!-- /range_values -->

    <!-- estimate_station_property section -->
    <section [class.hide]="!stationProperties?.length">
      <mat-form-field>
        <mat-label>Est Station Property</mat-label>
        <mat-select formControlName="estimate_station_property" [errorStateMatcher]="matcher">
          <mat-option>Select station property</mat-option>
          @for (prop of stationProperties; track prop) {
            <mat-option [value]="prop">
              <div>{{prop}}</div>
            </mat-option>
          }
        </mat-select>
        @if (inputForm.controls.estimate_station_property.hasError('required')) {
          <mat-error>
            This field is <strong>required</strong>
          </mat-error>
        }
        @if (inputForm.controls.estimate_station_property.hasError('error')) {
          <mat-error>
            {{inputForm.controls.estimate_station_property.errors.error}}
          </mat-error>
        }
      </mat-form-field>
    </section>
    <!-- /estimate_station_property section -->

    <!-- recent_field section -->
    <section [class.hide]="!captureRecentField">
      <mat-form-field>
        <mat-label>Recent field</mat-label>
        <mat-select formControlName="recent_field_id" [errorStateMatcher]="matcher">
          <mat-option>Select recent field</mat-option>
          @for (record of fields; track record) {
            <mat-option [value]="record.id">
              <div>{{record.label}}</div>
            </mat-option>
          }
        </mat-select>
        @if (inputForm.controls.recent_field_id.hasError('required')) {
          <mat-error>
            This field is <strong>required</strong>
          </mat-error>
        }
        @if (inputForm.controls.recent_field_id.hasError('error')) {
          <mat-error>
            {{inputForm.controls.recent_field_id.errors.error}}
          </mat-error>
        }
      </mat-form-field>
    </section>
    <!-- /recent_field section -->

    <!-- recent_field_label section -->
    <section [class.hide]="!captureRecentField">
      <mat-form-field>
        <mat-label>Recent field label</mat-label>
        <input matInput autocomplete="off" formControlName="recent_field_label" [errorStateMatcher]="matcher" />
        @if (inputForm.controls.recent_field_label.hasError('required')) {
          <mat-error>
            This field is <strong>required</strong>
          </mat-error>
        }
        @if (inputForm.controls.recent_field_label.hasError('error')) {
          <mat-error>
            {{inputForm.controls.recent_field_label.errors.error}}
          </mat-error>
        }
      </mat-form-field>
    </section>
    <!-- /recent_field_label section -->

    <section>&nbsp;</section>
    <!-- Form Actions -->
    <section>
      @if (editing) {
        <div class="row">
          <button mat-stroked-button color="accent" [disabled]="!canEdit" (click)="save(inputForm)">
            @if (field?.id) {
              Update
            }
            @if (!field?.id) {
              Create
            }
          </button>
          <button mat-stroked-button (click)="onCancel()" [disabled]="!canEdit">Cancel</button>
        </div>
      }
    </section>
    <!-- Form Actions -->
  </form>
  <!-- /Input form -->
</ng-template>